import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { defineMessages, useIntl } from "react-intl";
import { makeStyles } from "tss-react/mui";
import "../button/Buttons.js";
import "../button/EditButton.js";
import "@mui/material";
import "@mui/material/Popover";
import "../../localization/MessageLocalizer.js";
import "../../localization/LocaleProvider.js";
import "../../localization/sharedResources.js";
import "../dropdown/DropdownHoc.style.js";
import { DropdownWithChip } from "../dropdown/DropdownWithChip.js";
import "../dropdown/DropdownItem.js";
import "../form/Form.js";
import { FormControlGroup } from "../form/FormControlGroup.js";
import "../form/FormLabel.js";
import "../form/ToggleSwitch.js";
import { useValidationFormatter, RuleType } from "../input/validation.js";
import "../input/DatePicker.js";
import "../input/DateRangePicker.js";
import "../input/StyledInput.js";
import { FormTextInputDefault } from "../input/FormInput.js";
import "../input/StyledFormInputHoc.js";
import "moment-timezone";
import "../input/DateSinglePicker.localize.js";
import "../input/hooks.js";
const useClasses = makeStyles()((theme) => ({
  filterContainer: {
    display: "grid",
    padding: theme.spacing(2),
    gap: theme.spacing(2)
  },
  filterForm: {
    display: "grid",
    gap: theme.spacing(1)
  }
}));
const localized = defineMessages({
  title: {
    id: "PhoneFilter_title",
    defaultMessage: "Phone"
  },
  area: {
    id: "PhoneFilter_Area",
    defaultMessage: "Area"
  },
  mobile: {
    id: "PhoneFilter_Mobile",
    defaultMessage: "Mobile"
  },
  any: {
    id: "PhoneFilter_Any",
    defaultMessage: "Any"
  },
  areaPatternMessage: {
    id: "PhoneFilter_AreaPatternMessage",
    defaultMessage: "Area is invalid"
  },
  mobilePatternMessage: {
    id: "PhoneFilter_MobilePatternMessage",
    defaultMessage: "Mobile is invalid"
  }
});
function PhoneFilter({ value, onChange }) {
  const { classes } = useClasses();
  const { formatMessage } = useIntl();
  const validationMessageFormatter = useValidationFormatter();
  const { control, handleSubmit, getValues, reset, formState, trigger } = useForm({
    defaultValues: {
      area: value?.area,
      mobile: value?.mobile
    }
  });
  useEffect(() => {
    if (value?.area && value?.mobile) {
      reset({
        area: value?.area,
        mobile: value?.mobile
      });
    }
  }, [value?.area, value?.mobile]);
  return /* @__PURE__ */ React.createElement(
    DropdownWithChip,
    {
      label: localized.title,
      selectedText: value?.area && value?.mobile ? `${value.area}${value.mobile}` : localized.any,
      applyAction: true,
      cancelAction: true,
      onApplyClick: handleSubmit(onChange),
      onCancelClick: reset,
      isApplyDisabled: !formState.isValid,
      styles: {
        dropdownContainer: classes.filterContainer
      },
      onKeyDownCapture: (e) => e.stopPropagation()
    },
    /* @__PURE__ */ React.createElement("div", { className: classes.filterForm }, /* @__PURE__ */ React.createElement(FormControlGroup, { label: formatMessage(localized.area), labelVariant: "default", labelPlacement: "left" }, /* @__PURE__ */ React.createElement(
      Controller,
      {
        control,
        name: "area",
        render: ({ field, fieldState }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
          FormTextInputDefault,
          {
            value: field.value,
            onChange: (e) => {
              field.onChange(e);
              trigger(["area", "mobile"]);
            },
            fieldState,
            placeholder: "+123",
            hideLabel: true,
            hasBottomSpacing: false
          }
        )),
        rules: {
          validate: (value2) => {
            const number = getValues("mobile");
            return number && !value2 ? validationMessageFormatter(RuleType.Required, localized.area) : true;
          },
          pattern: {
            value: /^\+\d+$/,
            message: formatMessage(localized.areaPatternMessage)
          }
        }
      }
    )), /* @__PURE__ */ React.createElement(FormControlGroup, { label: formatMessage(localized.mobile), labelVariant: "default", labelPlacement: "left" }, /* @__PURE__ */ React.createElement(
      Controller,
      {
        control,
        name: "mobile",
        render: ({ field, fieldState }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
          FormTextInputDefault,
          {
            value: field.value,
            onChange: (e) => {
              field.onChange(e);
              trigger(["area", "mobile"]);
            },
            fieldState,
            placeholder: "4567890",
            hideLabel: true,
            hasBottomSpacing: false,
            type: "number"
          }
        )),
        rules: {
          validate: (value2) => {
            const area = getValues("area");
            return area && !value2 ? validationMessageFormatter(RuleType.Required, localized.mobile) : true;
          },
          pattern: {
            value: /^\d+$/,
            message: formatMessage(localized.mobilePatternMessage)
          }
        }
      }
    )))
  );
}
export {
  PhoneFilter
};
//# sourceMappingURL=PhoneFilter.js.map
